import { getTimezones } from "@eventbuilder-utils/datetime";
import EBModalLayout from "../layouts/modal.js";

export default class DateTimeTimezonePickerModal extends EBModalLayout {
    data = { date: "", time: "", timezone: "" };

    constructor(timestamp, timeZone, opts = {time: true, timezone: true}) {
        const atTime = opts.timezone ? new Date(new Date(timestamp).toLocaleString("en-US", { timeZone: timeZone })) : new Date(new Date(timestamp).toLocaleString("en-US"));

        super({}, {
            className: "modal--md",
            title: "Date Picker",
            content: `
                <form style="display:flex;column-gap:var(--spacing-md);">
                    <input type="date" name="date" value="${atTime.getFullYear()}-${(atTime.getMonth()+1).toString().padStart(2,"0")}-${atTime.getDate().toString().padStart(2,"0")}" required>
                    ${opts.time ? `<input type="time" name="time" value="${atTime.getHours().toString().padStart(2,"0")}:${atTime.getMinutes().toString().padStart(2,"0")}" required>` : ""}
                    ${opts.timezone ? `<select name="timezone" style="flex:1 1 auto;" value="${timeZone}" required>
                        ${getTimezones().map(zone => {
                            if (zone.ianaZone === timeZone) {
                                return `<option value="${zone.ianaZone}" selected>${zone.displayName}</option>`
                            } else {
                                return `<option value="${zone.ianaZone}">${zone.displayName}</option>`
                            }
                        }).join("")}
                    </select>` : ""}
                </form>`
        });

        this.addControl("Save", { className: "primary" }).addEventListener("click", (ev) => {
            const data = new FormData(this.element.querySelector("form"));
            
            const atTime = new Date(`${data.get("date")}T${opts.time ? data.get("time") : '00:00'}:00.000`);
            const localTime = new Date(atTime.toLocaleString("en-US"));
            const remoteTime = opts.timezone ? new Date(atTime.toLocaleString("en-US", {timeZone: data.get("timezone")})) : new Date(atTime.toLocaleString("en-US"));
            const adjustBy = Math.round((localTime.getTime() - remoteTime.getTime()));

            this.close({
                timestamp: atTime.getTime() + adjustBy,
                timezone: data.get("timezone")
            });
        });
        
        this.addControl("Cancel").addEventListener("click", (ev) => {
            this.close();
        });
        this.initialize();
    }
}